<div style="height: 95vh">
    <mat-calendar
        [minDate]="currentDate"
        [(selected)]="selectedDate"
        (monthSelected)="ladeVerfuegbareZeitslots($event)"
        (selectedChange)="daySelected($event)"
    ></mat-calendar>
    <ng-container *ngIf="day.length === 0">
        <div style="margin-top: 24px">Keine Zeitslots mehr für diesen Tag!</div>
    </ng-container>
    <ng-container *ngIf="day.length > 0">
        <mat-list>
            <mat-list-item style="cursor: pointer" *ngFor="let slot of day">
                <div matLine
                    >{{ slot?.datum_uhrzeit_von | date: "HH:mm" }} - {{ slot?.datum_uhrzeit_bis | date: "HH:mm" }} Uhr
                </div>
                <div matLine>Freie Kapazität: {{ slot?.rest_kapazitaet }} Tiere</div>
                <button mat-flat-button color="accent" (click)="this.bottomSheetRef.dismiss(slot)"> Auswählen </button>
            </mat-list-item>
        </mat-list>
    </ng-container>
</div>
